import React, { useState } from "react";
import styles from "./viewTreatment.module.scss";
import { CloseWarning } from "../CloseWarning";
import { signedLockedAccess } from "../../../utils";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Form } from "../../primary";
import { CANCEL_BTN, CANCEL_ID, SAVE_BTN, SUBMIT_ID } from "../../../constants";
import { FormActions } from "../FormActions/FormActions";
import { TreatmentDropDownItemNew } from "../TreatmentDropDownItem";
import { TreatmentSearch } from "../TreatmentDropDownItem/TreatmentSearch";
import { PERMISSIONS } from "../../../constants/permissions";
import { useReadOnly } from "../../../hooks/useReadOnly";

export const TreatmentEditForm = ({
  editData,
  setFormChangesConfirm,
  isPrimSec,
  setIsPrimSec,
  saveData,
  setEditable,
  dressing,
  setCloseWarningSec,
  viewScreen,
  dropValue,
  setGetValueDrop,
  handleCancel,
  hasPermission,
}) => {
  const isReadOnly = useReadOnly();
  const { handleSubmit } = useForm();
  const assessmentDetails = useSelector((state) => state.patient.detailAssessment);
  const [closeWarning, setCloseWarning] = useState(false);

  const treatmentViewData = useSelector((state) => state.patient.treatmentViewData);

  const yesFun = () => {
    setCloseWarning(false);
  };

  const noFun = () => {
    setCloseWarning(false);
  };

  const doSubmit = () => {
    const sub = treatmentViewData?.flatMap((item) => {
      if (Array.isArray(item.value)) {
        return item.value.map((val) => ({
          key: item.key,
          value: val,
          isRecommended: item.isRecommended,
        }));
      }
      return item;
    });

    saveData(sub);
    setEditable(false);
  };

  const getOptValue = () => {
    if (dressing === "primary" || dressing === "secondary") {
      setIsPrimSec(true);
    }

    if (setCloseWarningSec) {
      setCloseWarningSec(false);
    }
    setFormChangesConfirm(true);
  };

  const searchableEditData = editData?.filter((item) => item.key !== "-1") || [];

  return (
    <>
      {closeWarning && (
        <CloseWarning message={`Are you sure you would like to proceed with your secondary dressing selection?`} yesFn={yesFun} noFn={noFun} />
      )}
        <Form setFormChangesConfirm={setFormChangesConfirm} directChanges={isPrimSec} className="col-12 p-0" onSubmit={handleSubmit(doSubmit)} requiredPermission={PERMISSIONS.TREATMENT} disabled={isReadOnly || !signedLockedAccess(assessmentDetails?.assessmentStage)}>
          {hasPermission(PERMISSIONS.TREATMENT_SEARCH) && searchableEditData.length > 0 && (
            <TreatmentSearch editData={searchableEditData} getData={getOptValue} dressing={dressing} />
          )}

          {editData &&
            Array.isArray(editData) &&
            editData.length > 0 &&
            editData.map((item, index) => {
              return (
                <TreatmentDropDownItemNew
                  index={item.key}
                  key={index}
                  id={item.key}
                  name={item.key}
                  label={`${item.name}`}
                  classes={{
                    column: `col-12 ${styles.col_spec} d-flex mb-2`,
                    inputClassName: styles.basic_select,
                    inputColumn: `col-6 p-0`,
                    labelClassName: `col-12 p-0`,
                  }}
                  listOptions={item.options}
                  getData={getOptValue}
                  viewScreen={viewScreen}
                  dressing={dressing ? dressing : "secondary"}
                  dropValue={dropValue}
                  setGetValueDrop={setGetValueDrop}
                  disabled={!hasPermission(PERMISSIONS.TREATMENT_EDIT)}
                />
              );
            })}
          {editData?.length !== 0 ? (
            <FormActions
              primaryLabel={SAVE_BTN}
              primaryId={SUBMIT_ID}
              primaryType="submit"
              secondaryLabel={CANCEL_BTN}
              secondaryId={CANCEL_ID}
              onSecondaryClick={handleCancel}
            />
          ) : (
            ""
          )}
        </Form>
    </>
  );
};
